/**
 * @file        src/pages/flight/cells.jsx
 * @description Shared table-cell renderers for the B2C Flight admin lists
 *              (customer identity with Guest fallback, money, ID chip).
 * @author      Kinetika Labs
 * @created     2026-07-09
 * @changelog
 *   - 2026-07-09 Claude — Initial: Guest-aware customer cell + id/money helpers.
 *   - 2026-07-08 Claude — "Guest" now keys off login state (user_id), NOT a
 *                          missing name. A logged-in customer with no saved name
 *                          shows their email WITHOUT the Guest tag; only bookings
 *                          made without login (no user_id, or the legacy guest
 *                          placeholder user_id=1) get the "Guest" chip.
 *   - 2026-08-10 Claude — Re-exports lib/docAccess: one shared rule for which
 *                          document actions a booking status allows (drawer,
 *                          row menu and the doc pages themselves all read it).
 */
import Chip from '../../components/Chip';

// One client-approved status→documents rule, shared with the hotel module.
export { docAccess } from '../../lib/docAccess';

export const money = (v) => (v == null ? '—' : `₹${Number(v).toLocaleString('en-IN')}`);

export const idCell = (v) => (v == null ? '—' : <span className="mono">#{v}</span>);

/**
 * Customer identity for a booking/search row. "Guest" marks a booking placed
 * WITHOUT logging in — detected from user_id (guests have none, or the legacy
 * placeholder id 1), never from a missing name. Registered customers show their
 * name/email with no tag even when the name wasn't captured.
 */
export function customerCell(_v, r) {
  const name = String(r.customer_name || '').trim();
  const email = r.customer_email || '';
  const isGuest = !r.user_id || Number(r.user_id) === 1;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <div>
        {name ? <div>{name}</div> : null}
        {email ? <div className={name ? 'muted' : undefined} style={name ? { fontSize: '.85em' } : undefined}>{email}</div> : null}
        {!name && !email ? <span className="muted">—</span> : null}
      </div>
      {isGuest ? <Chip tone="warn">Guest</Chip> : null}
    </div>
  );
}
